import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import './Login.css'

export default function Login() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    setLoading(true)
    setError('')
    setTimeout(() => {
      const ok = login(password)
      if (ok) {
        navigate('/dashboard')
      } else {
        setError('Mot de passe incorrect. Contactez l\'équipe de direction.')
        setLoading(false)
      }
    }, 300)
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-logo" style={{justifyContent:'center'}}>
          <img src="/GL_sansvague_noir_carre_65.png" alt="Groupe Leclair" style={{width:'140px'}} />
        </div>

        <h1>Connexion</h1>
        <p className="login-desc">Entrez le mot de passe pour accéder au tableau de bord.</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
              autoFocus
            />
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Connexion…' : 'Accéder au tableau de bord'}
          </button>
        </form>

        <div className="login-footer">
          Groupe Leclair · Confidentiel
        </div>
      </div>
    </div>
  )
}
